module.exports = __webpack_public_path__ + "static/media/Team 31 Waste Matters - krisha sakhrani.bdb2c344.png";